import weekCut from "./weekCut";
import currentWeek from "./currentWeek";
import monthCut from "./monthCut";

/**
 * @author Alejandro.g.g
 * @param {string} type
 * @returns {Array}
 */

function CheckType(type) {
  var dateStart = "";
  var dateEnd = "";

  switch (type) {
    case "Día":
      dateStart = new Date().toISOString().substring(0, 10) + "T00:00:00.000Z";
      dateEnd = new Date().toISOString().substring(0, 10) + "T23:59:59.999Z";
      break;
    case "Semana":
      dateStart = weekCut()[0];
      dateEnd = weekCut()[1];
      break;
    case "Mes":
      dateStart = monthCut()[0];
      dateEnd = monthCut()[1];
      break;
    case "current":
      dateStart = currentWeek()[0];
      dateEnd = currentWeek()[1];
      break;
    default:
      break;
  }
  return [dateStart, dateEnd];
}

export default CheckType;
